import { gql } from '@apollo/client';

// Lokalise counterparts of the LanguageWire operations in ../TranslationProject.tsx.
// Both chains stay deployed; the team's translationProvider decides which one the UI uses.

export const GET_TRANSLATION_PROVIDER = gql`
  query TranslationProvider {
    currentTeam {
      id
      translationProvider
    }
  }
`;

export const CREATE_LOKALISE_PROJECT = gql`
  mutation CreateLokaliseProject(
    $pageId: ID!
    $briefing: String!
    $translationType: String!
  ) {
    createLokaliseProject(
      pageId: $pageId
      briefing: $briefing
      translationType: $translationType
    ) {
      translationJob {
        id
        state
        translationType
        expectedLocales
        keyIds
      }
      errors
    }
  }
`;

export const CHECK_TRANSLATION_JOB_STATUS = gql`
  query CheckTranslationJobStatus($pageId: ID!) {
    checkTranslationJobStatus(pageId: $pageId) {
      translationJobId
      state
      translationType
      expectedLocales
      receivedLocales
      pendingLocales
      uploadedAt
      completedAt
      stalledSince
      pageStatus
    }
  }
`;

export const GET_TRANSLATION_JOBS = gql`
  query TranslationJobs {
    translationJobs {
      id
      title
      briefing
      pageId
      state
      translationType
      stalledSince
      createdAt
      completedAt
      pageStatus
      blobName
      createdBy {
        id
        email
      }
    }
  }
`;

// The three values the translation service accepts. "selective languages" means a reduced set
// agreed out of band with the customer's localization team, so such a job never reports complete.
export const TRANSLATION_TYPES = [
  'standard AI',
  'proAI',
  'selective languages',
] as const;
export type TranslationType = (typeof TRANSLATION_TYPES)[number];
